module.exports = __webpack_public_path__ + "img/img1.b4d40134.png";